<template>
    <div class="mainHolder">
        <div id="sec-one">
            <div class="outer">
                <div class="content">
                    <div class="item">
                        <div id="leftPanel">
                            <TopBar/>
                            <div id="mainMenuSelected">SEND MESSAGE</div>
                            <p class="infoOption">Please select a message type:</p>
                            <MainMenu
                               
                            />
                        </div>
                         
                    </div>
                </div>
            </div>
        </div>
        <div id="sec-two" >
            <div class="outer">
                <div class="content">
                    <div class="p15">
                        <Logo className="item pt30 smallMainLogo"/>
                    </div>
                    <div class="bg-two">
                        <div> <!-- goes the form-->
                              
                            <form @submit.prevent="sendMsgBox">
                                <div v-if="!loadingPage">
                                    <div class="content-schedule">
                                        <div class="info-schedule">
                                            <div>
                                                <!--
                                                {{ setContent(filter.content, filter.variables) }}
                                                {{ setVariables(filter.variables) }}
                                                -->
                                                <div v-html="filter.content"></div>
                                                
                                                <!--
                                                Your Milwaukee repair <input type="text" class="youRepair"><br>
                                                has been <span class="bold">completed and is ready for pick up at our Factory Service Centre.</span> 
                                                <br><br>
                                                
                                                <span class="italic">We are open from: 8:00 am to 4:30 pm <br>
                                                Monday through Friday</span>
                                                -->
                                                 
                                                <!--
                                                {{ handleNewLine(item.content) }}
                                                <div v-html="item.content"></div>
                                                <p>Using v-html directive: <span v-html="item.content"></span></p>
                                                -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="schedule-form">
                                        <div class="field-form">
                                            <input type="text" placeholder="Please copy the SV or MODEL number here..." v-model.trim="sv_model" id="sv_model" autocomplete="off">
                                        </div>
                                        <div class="field-form">
                                        <div class="client_number">
                                                <div>
                                                    <span>Customer's phone number:</span>
                                                </div>
                                                <div>
                                                    <input type="text" placeholder="(000) 000-0000" v-model.trim="phone_number" v-maska="'(###) ### ####'">
                                                </div>
                                        </div>
                                        </div>
                                        <div class="field-formx">
                                            <button
                                                class="btnSendSms"
                                                type="submit"  
                                                :disabled="blockBtn"
                                            >
                                                 <span v-if="!sendingForm">SEND</span> <span class="fa-1x" v-if="sendingForm"><i class="fas fa-spinner fa-spin redColor"></i></span>
                                            </button>
                                        </div>
                                        <div class="field-confirm">
                                            <label>
                                                <input 
                                                    type="checkbox" 
                                                    id="cbox1" 
                                                    value="confirm"
                                                    :disabled="requeresInputs"
                                                    v-model="check_confirm"
                                                    > I confirm the above message is correct
                                            </label><br>
                                        </div>
                                        <br>
                                        <br>
                                        <br>
                                    </div>   
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import {mapState, mapActions} from 'vuex'
import store from '../../store'
import TopBar from '../../components/TopBar.vue'
import MainMenu from '../../components/MainMenu.vue'
import Logo from '../../components/Logo'
import $ from 'jquery'
import axios from "axios";
//import Inputmask from"inputmask";

export default {
    props:[],
    components: {
        TopBar,
        MainMenu,
        Logo,
    },
    data() {
        return {
            user_login:[],
            filter: {
                nama:'',
                content:'',
                variables: ''
            },
            sv_model:'',
            phone_number:'',
            check_confirm: false,
            content:'',
            loadingPage: true,
            sendingForm: false,
            token_jwt:''
            
        };
    },
    computed:{
        blockBtn(){
            if (this.sv_model !== "" && this.phone_number !== "" && this.phone_number.length >= 14 && this.check_confirm && !this.sendingForm ) {   
                
                return false 
            }
            else
            { 
                return true
            }
        },

        requeresInputs(){
            
            if (this.sv_model !== "" && this.phone_number !== "") { 
                return false 
            }
            else
            { 
                this.check_confirm = false
                return true
            }
            
        }
    },
    watch: {
        $route(to) {
            this.getTemplate(to) //react to route changes...
        },
    },
    methods: {

        async getTemplate(){

            const self = this
            try{
                //=================================
                //Get cookie called user_login  
                //=================================  
                
                let filter = this.$store.state.templates.data.find(item => item.id === self.$route.params.id)
               
                if( filter )
                {
                    self.token_jwt = localStorage.getItem('token')//dataUser.data.jwt
                    self.filter.name = filter.name

                    self.filter.content = self.setContent(filter.content, filter.variables)
                    self.filter.variables = self.setVariables(filter.variables)
                    self.loadingPage = false;
                }
                
            }catch(error){
                console.log(error);
            }
        },

        setContent(content, variables){
          
            this.content = content
            let newString = content;
            for(var i=0; i < variables.length; i++)
            {
                newString = newString.replace("["+variables[i]+"]", "<span class='tmp_field'></span><br>"); 
                //_______________
            }
            return newString;
        },
        
        setVariables(valibale){
            this.variables = (valibale);
        },

        buildTemplate(content, replace, newValue){
            return content.replace("["+replace+"]", newValue);
        },
        
        async sendMsgBox(){
            const self = this;
            self.sendingForm = true;
            let content = this.buildTemplate(this.content, this.variables[0], this.sv_model);
            

            let formData = new FormData();
            formData.append("recipient", this.phone_number.replace(/\D/g, ""));
            formData.append("content", content);

            let dataUser = this.token_jwt;
            axios({
                method: "post",
                url: `https://www.miltoolsms.ca/api/v1/messages`,
                responseType: "json",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + dataUser
                }
            })
            .then(function(response) {
                if (response.data) {
                    self.callToast(`Thank you. Your message was successfully sent!`, 'success')
                    self.sv_model = ""
                    self.phone_number = ""
                    self.check_confirm = false
                }else{
                    self.callToast(`There was an error`, 'warning')
                }

                self.sendingForm = false
            })
            .catch(error => (self.callToast(`There was an error: ${error}`, 'warning'), (self.sendingForm = false)));     
        },

        callToast(message, status){
            this.$toast.show(message, {
                type: status,
                position: 'top-right'
                // all of other options may go here
            });
        },
        
        handleNewLine(str) {
            return str.replace(/(\\r)*\\n/g, '<br>')
        },
    },
    created(){
        
        this.getTemplate();
        
    }
}

</script>

<style>

</style>